import { Card, CardContent, cn } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

export type ListToolbarSurfaceProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  /**
   * `canvas` — bare row on the page (default Status Board dialect).
   * `card` — nested Card for dense filter rows (Leads/Reviews).
   */
  variant?: 'canvas' | 'card';
};

/**
 * Optional wrapper for list search/filter rows.
 * Prefer `canvas` unless the toolbar needs nested Card chrome.
 */
export function ListToolbarSurface({
  children,
  className,
  contentClassName,
  variant = 'canvas',
}: ListToolbarSurfaceProps) {
  if (variant === 'canvas') {
    return (
      <div className={cn('min-w-0', className)}>
        <div className={cn(contentClassName)}>{children}</div>
      </div>
    );
  }

  return (
    <Card className={cn(className)}>
      <CardContent className={cn('p-4 sm:p-5', contentClassName)}>
        {children}
      </CardContent>
    </Card>
  );
}
